import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {FormControl, Validators} from '@angular/forms';
import {WorkrequestSrpViewmodel} from '../workrequest-srp-viewmodel';
import {WorkrequestSrpDetails} from '../workrequest-srp-details';
import {AddressService } from '../../../shared/services/address.service';
import {Subscription } from 'rxjs';

// enum SERVICE_PROVIDER {
//   CWW = 'FMR CWW',
//   WW = 'FMR WW'
// }

@Component({
  selector: 'app-workrequest-srp',
  templateUrl: './workrequest-srp.component.html',
  styleUrls: ['./workrequest-srp.component.css']
})
export class WorkrequestSrpComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestSrpViewmodel;
  @Output()
  onViewModelChange: EventEmitter<WorkrequestSrpViewmodel>;
  @Output()
  onFeeCodesReceived: EventEmitter<void>;
  @Output()
  onWorkRequestOptionChanged: EventEmitter<string>;

  descriptionOfWorkControl: FormControl;
  propertyOnCombinedDrainYesControl: FormControl;
  propertyOnCombinedDrainNoControl: FormControl;
  applicationFeerequiredControl: FormControl;
  newHouse1requiredControl: FormControl;
  newHouse2requiredControl: FormControl;
  newOrExistingHouserequiredControl: FormControl;
  demolitionAndRebuildrequiredControl: FormControl;
  houseExtensionrequiredControl: FormControl;
  assessAndDesignrequiredControl: FormControl;
  belowGroundSewerWorkrequiredControl: FormControl;
  waterConsentOnlyrequiredControl: FormControl;
  divewayResponsibleOwnerControl: FormControl;
  divewayResponsibleBuilderControl: FormControl;
  divewayResponsibleExistingControl: FormControl;
  divewayResponsibleNoControl: FormControl;
  descriptionOfWorkControlMaxLength = 400;
  _isRecycledWaterZone: boolean;

  pricingZone: string;
  $subs: Subscription;
  // WW_dry_tapping_fees = 10.20;
  WW_dry_tapping_fees = 0;

  constructor(private loginService: LoginService, private cdRef: ChangeDetectorRef,
           private feeService: FeeService, private addressService: AddressService) {

    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestSrpViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestSrpDetails();
    }

    this.onFeeCodesReceived = new EventEmitter();
    this.onWorkRequestOptionChanged = new EventEmitter<string>();
    this.propertyOnCombinedDrainYesControl = new FormControl();
    this.propertyOnCombinedDrainNoControl = new FormControl();
    this.applicationFeerequiredControl = new FormControl({value: true, disabled: true});
    this.newHouse1requiredControl = new FormControl();
    this.newHouse2requiredControl = new FormControl();
    this.newOrExistingHouserequiredControl = new FormControl();
    this.demolitionAndRebuildrequiredControl = new FormControl();
    this.houseExtensionrequiredControl = new FormControl();
    this.assessAndDesignrequiredControl = new FormControl();
    this.belowGroundSewerWorkrequiredControl = new FormControl();
    this.waterConsentOnlyrequiredControl = new FormControl();
    this.divewayResponsibleOwnerControl = new FormControl();
    this.divewayResponsibleBuilderControl = new FormControl();
    this.divewayResponsibleExistingControl = new FormControl({value: true, disabled: true});
    this.divewayResponsibleNoControl = new FormControl({value: true, disabled: true});
    this.descriptionOfWorkControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.descriptionOfWorkControlMaxLength)
    ])]);
  }

  ngOnInit() {
    this.loadFees();

    // fetch pricing zone (CWW / WW)
    this.$subs = this.addressService.getPricingZone().subscribe(_pricingZone => {
      this.pricingZone = _pricingZone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);

      // load fees again after pricing zone is updated
      this.loadFees();
      //this.applicationFeerequired = false;
      this.calculateTotalAmount();
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnDestroy() {
    this.$subs.unsubscribe();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
    this.calculateTotalAmount();
  }

  loadFees() {
    this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), ok => {
        if (ok) {
          // this.workRequestViewModel.applicationFeeAmount = this.pricingZone === SERVICE_PROVIDER.CWW ?
          //                                                     this.feeService.getSRPApplicationFeeAmount(this.pricingZone) : 0;
          this.workRequestViewModel.applicationFeeAmount = this.feeService.getSRPApplicationFeeAmount(this.pricingZone);
          // this.workRequestViewModel.workrequestDetails.applicationFeerequired = this.pricingZone === SERVICE_PROVIDER.CWW;
          this.workRequestViewModel.workrequestDetails.applicationFeerequired = true;
          this.onFeeCodesReceived.emit();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  get isPricingZongCWW(): boolean {
    return this.pricingZone == SERVICE_PROVIDER.CWW;
  }

  get invalidDivewayError(): string {
    return this.workRequestViewModel.invalidDivewayError;
  }

  get invalid(): boolean {
    this.workRequestViewModel.invalidDivewayError = null;
    if (!this.validateAll()) {
      return true;
    }

    if (this.descriptionOfWorkControl.invalid) {
      return true;
    }

    if (!this.divewayResponsibleOwner) {
      //this.workRequestViewModel.invalidDivewayError = 'Please select who is responsible for constructing the driveway?';
      return true;
    }

    return false;
  }

  isUserDriveway(): boolean {
    return !this.workRequestViewModel.workrequestDetails.isUserDriveway;
  }

  get whoIsResponsible(): string {
    switch (this.divewayResponsibleOwner) {
      case 'nodriveway':
        return 'No driveway work required.';
      case 'existingdriveway':
        return 'There is an Existing driveway.';
      default:
        return this.divewayResponsibleOwner;
    }
  }

  get isPropertyOnCombinedDrain(): string {
    switch (this.propertyOnCombinedDrain) {
      case 'yes':
        return 'Yes';
      case 'no':
        return 'No';
      default:
        return 'None';
    }
  }

  public validateAll(): boolean {
    this.workRequestViewModel.invalidSelectionError = '';

    // if (this.pricingZone === SERVICE_PROVIDER.CWW && !this.validateApplicationFee()) {
    if (!this.validateApplicationFee()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select Application Fee.';
      return false;
    }

    if (!this.validateNewSimpleConnection() && !this.validateAlterationAddition()
      && !this.validateWaterOnly()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid work request';
      return false;
    }

    if (this.validateNewSimpleConnection() && this.validateAlterationAddition()
      && this.validateWaterOnly()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid work request';
      return false;
    }

    if (this.validateNewSimpleConnection() && this.validateAlterationAddition()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid work request';
      return false;
    }

    if (this.validateNewSimpleConnection() && this.validateWaterOnly()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid work request';
      return false;
    }

    if (this.validateAlterationAddition()
      && this.validateWaterOnly()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid work request';
      return false;
    }
    return true;
  }

  public validateApplicationFee(): boolean {
    return this.applicationFeerequired;
  }

  public validateNewSimpleConnection(): boolean {
    return (!this.isRecycledWaterZone && this.newHouse1required)
      || (this.isRecycledWaterZone && this.newHouse2required)
      || this.NewOrExistingHouserequired;
  }

  public validateAlterationAddition(): boolean {
    return this.demolitionAndRebuildrequired || this.houseExtensionrequired
      || this.assessAndDesignrequired || this.belowGroundSewerWorkrequired;
  }

  public validateWaterOnly(): boolean {
    return this.waterConsentOnlyrequired;
  }

  set divewayResponsibleOwner(v: string) {
    this.workRequestViewModel.workrequestDetails.divewayResponsibleOwner = v;
  }

  get divewayResponsibleOwner(): string {
    return this.workRequestViewModel.workrequestDetails.divewayResponsibleOwner;
  }

  public calculateTotalAmount(): void {
    //if (this.pricingZone === SERVICE_PROVIDER.WW) {
    //  if (this.newHouse1required || this.newHouse2required) {
    //    this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.WW_dry_tapping_fees;
    //  } else {
    //    this.workRequestViewModel.workrequestDetails.totalOrderAmount = 0;
    //  }

    //} else {

    this.workRequestViewModel.workrequestDetails.totalOrderAmount = 0;
    if (this.isApplicationFeeSectionVisible() && this.applicationFeerequired) {
      this.workRequestViewModel.workrequestDetails.totalOrderAmount = this.workRequestViewModel.applicationFeeAmount;
    }
    //}
  }

  public isApplicationFeeSectionVisible(): boolean {
    return !(this.pricingZone == SERVICE_PROVIDER.WW && this.waterConsentOnlyrequired);
  }

  set propertyOnCombinedDrain(v: string) {
    this.workRequestViewModel.workrequestDetails.propertyOnCombinedDrain = v;
    const ret: boolean = this.validateAll();
  }

  set applicationFeeAmount(v: number) {
    this.workRequestViewModel.applicationFeeAmount = v;
  }

  set applicationFeerequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.applicationFeerequired = v;
    // this.workRequestViewModel.workrequestDetails.applicationFeerequired = this.pricingZone === SERVICE_PROVIDER.CWW ? v : false;
    //this.calculateTotalAmount();
    //const ret: boolean = this.validateAll();
  }

  set newHouse1required(v: boolean) {
    this.workRequestViewModel.workrequestDetails.newHouse1required = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set newHouse2required(v: boolean) {
    this.workRequestViewModel.workrequestDetails.newHouse2required = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set NewOrExistingHouserequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.NewOrExistingHouserequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set demolitionAndRebuildrequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.demolitionAndRebuildrequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set houseExtensionrequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.houseExtensionrequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set assessAndDesignrequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.assessAndDesignrequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set belowGroundSewerWorkrequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.belowGroundSewerWorkrequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  set waterConsentOnlyrequired(v: boolean) {
    this.workRequestViewModel.workrequestDetails.waterConsentOnlyrequired = v;
    this.calculateTotalAmount();
    const ret: boolean = this.validateAll();
  }

  @Input()
  set isRecycledWaterZone(v: boolean) {
    if (!v) {
      this.newHouse2required = false;
    }
    this._isRecycledWaterZone = v;
  }

  set applicationDate(v: string) {
    this.workRequestViewModel.applicationDate = v;
  }

  set requiredWorkRequest(v:string) {
    this.workRequestViewModel.workrequestDetails.requiredWorkRequest = v;
    switch (v) {
      case 'NewHouse1required':
        this.newHouse1required = true;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = '';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = true;
        this.divewayResponsibleExistingControl.disable();
        this.divewayResponsibleNoControl.disable();
        break;
      case 'NewHouse2required':
        this.newHouse1required = false;
        this.newHouse2required = true;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = '';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = true;
        this.divewayResponsibleExistingControl.disable();
        this.divewayResponsibleNoControl.disable();
        break;
      case 'NewOrExistingHouserequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = true;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = '';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = true;
        this.divewayResponsibleExistingControl.disable();
        this.divewayResponsibleNoControl.disable();
        break;
      case 'demolitionAndRebuildrequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = true;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = '';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = true;
        this.divewayResponsibleExistingControl.enable();
        this.divewayResponsibleNoControl.enable();
        break;
      case 'houseExtensionrequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = true;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = 'nodriveway';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = false;
        this.divewayResponsibleExistingControl.disable({onlySelf: true});
        this.divewayResponsibleNoControl.disable({onlySelf: true});
        break;
      case 'assessAndDesignrequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = true;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = 'nodriveway';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = false;
        this.divewayResponsibleExistingControl.disable();
        this.divewayResponsibleNoControl.disable();
        break;
      case 'belowGroundSewerWorkrequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = true;
        this.waterConsentOnlyrequired = false;
        this.divewayResponsibleOwner = 'nodriveway';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = false;
        this.divewayResponsibleExistingControl.disable();
        this.divewayResponsibleNoControl.disable();
        break;
      case 'waterConsentOnlyrequired':
        this.newHouse1required = false;
        this.newHouse2required = false;
        this.NewOrExistingHouserequired = false;
        this.demolitionAndRebuildrequired = false;
        this.houseExtensionrequired = false;
        this.assessAndDesignrequired = false;
        this.belowGroundSewerWorkrequired = false;
        this.waterConsentOnlyrequired = true;
        this.divewayResponsibleOwner = '';
        this.workRequestViewModel.workrequestDetails.isUserDriveway = true;
        this.divewayResponsibleExistingControl.enable();
        this.divewayResponsibleNoControl.enable();
        break;
    }

    this.calculateTotalAmount();
    this.onWorkRequestOptionChanged.emit(v); // if waterConsentOnlyrequired, hide payment tab
  }

  get applicationFeeAmount(): number {
    return this.workRequestViewModel.applicationFeeAmount;
  }

  get propertyOnCombinedDrain(): string {
    return this.workRequestViewModel.workrequestDetails.propertyOnCombinedDrain;
  }

  get applicationFeerequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.applicationFeerequired;
  }

  get newHouse1required(): boolean {
    return this.workRequestViewModel.workrequestDetails.newHouse1required;
  }

  get newHouse2required(): boolean {
    return this.workRequestViewModel.workrequestDetails.newHouse2required;
  }

  get NewOrExistingHouserequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.NewOrExistingHouserequired;
  }

  get demolitionAndRebuildrequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.demolitionAndRebuildrequired;
  }

  get houseExtensionrequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.houseExtensionrequired;
  }

  get assessAndDesignrequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.assessAndDesignrequired;
  }

  get belowGroundSewerWorkrequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.belowGroundSewerWorkrequired;
  }

  get waterConsentOnlyrequired(): boolean {
    return this.workRequestViewModel.workrequestDetails.waterConsentOnlyrequired;
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  }

  get applicationDate(): string {
    return this.workRequestViewModel.applicationDate;
  }

  get isRecycledSelected(): boolean {
    return this.newHouse2required || this.demolitionAndRebuildrequired || this.NewOrExistingHouserequired
      || this.houseExtensionrequired || this.waterConsentOnlyrequired;
  }

  get isBelowGroundPlumbingSelected(): boolean {
    return this.newHouse1required || this.newHouse2required || this.NewOrExistingHouserequired || this.demolitionAndRebuildrequired
      || this.houseExtensionrequired || this.assessAndDesignrequired || this.belowGroundSewerWorkrequired || this.waterConsentOnlyrequired;
  }

  get isDrinkingWaterSelected(): boolean {
    return this.newHouse1required || this.newHouse2required || this.NewOrExistingHouserequired || this.demolitionAndRebuildrequired
      || this.waterConsentOnlyrequired;
  }

  get isBelowGroundPlumbingMandatory(): boolean {
    return this.newHouse1required || this.newHouse2required || this.NewOrExistingHouserequired || this.demolitionAndRebuildrequired
      || this.houseExtensionrequired || this.belowGroundSewerWorkrequired;
  }

  get isDrinkingWaterMandatory(): boolean {
    return this.newHouse1required || this.newHouse2required || this.NewOrExistingHouserequired || this.demolitionAndRebuildrequired
      || this.houseExtensionrequired || this.waterConsentOnlyrequired;
  }

  get isRecycledWaterMandatory(): boolean {
    return this.newHouse1required || this.newHouse2required || this.NewOrExistingHouserequired || this.demolitionAndRebuildrequired
      || this.houseExtensionrequired || this.waterConsentOnlyrequired;
  }

  get isValidSelection(): boolean {
    return this.validateAll();
  }

  get isRecycledWaterZone(): boolean {
    return this._isRecycledWaterZone;
  }

  get invalidSelectionError(): string {
    return this.workRequestViewModel.invalidSelectionError;
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  get requiredWorkRequest(): string {
    return this.workRequestViewModel.workrequestDetails.requiredWorkRequest;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  displayErrorMessage(): string {
    this.newHouse1requiredControl.markAsTouched();
    this.newHouse2requiredControl.markAsTouched();
    this.newOrExistingHouserequiredControl.markAsTouched();
    this.demolitionAndRebuildrequiredControl.markAsTouched();
    this.houseExtensionrequiredControl.markAsTouched();
    this.assessAndDesignrequiredControl.markAsTouched();
    this.belowGroundSewerWorkrequiredControl.markAsTouched();
    this.waterConsentOnlyrequiredControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (!this.validateAll()) {
      errorText += this.workRequestViewModel.invalidSelectionError + '<br>';
    }
    if (!this.divewayResponsibleOwner) {
      errorText += 'Please select who is responsible for constructing the driveway?' + '<br>';
    }
    this.descriptionOfWorkControl.markAsTouched();
    if (this.descriptionOfWorkControl.invalid) {
      if (this.descriptionOfWorkControl.hasError('maxlength')) {
        errorText += 'Description of work cannot exceed ' + this.descriptionOfWorkControlMaxLength + ' characters' + '<br>';
      }
      if (this.descriptionOfWorkControl.hasError('required')) {
        errorText += 'Please enter description of work' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.newHouse1requiredControl.markAsUntouched();
    this.newHouse2requiredControl.markAsUntouched();
    this.newOrExistingHouserequiredControl.markAsUntouched();
    this.demolitionAndRebuildrequiredControl.markAsUntouched();
    this.houseExtensionrequiredControl.markAsUntouched();
    this.assessAndDesignrequiredControl.markAsUntouched();
    this.belowGroundSewerWorkrequiredControl.markAsUntouched();
    this.waterConsentOnlyrequiredControl.markAsUntouched();
    this.descriptionOfWorkControl.markAsUntouched();
    this.loadFees();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/srp-form/workrequest-srp/workrequest-srp.component.ts